﻿import TKStock from '@tk/components/tk.stock';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import { ResponseItem, StockData } from '@tk/components/tk.article.list';
import isBase64, { fromBase64 } from '@tk/utilities/tk.base64';

const READY_TO_RUN_ATTR = 'data-tk-ready-to-run';
const QUANTITY_CHECK_ATTR = 'data-tk-stock-check-qty';
const DIMENSION_VARIANT_ATTR = 'data-tk-dimension-variant';

export default class KWStock extends TKStock {
    asyncURLEncrypt: string | null;
    readyToRun?: boolean;
    isCached: boolean;
    checkQuantity: number | undefined;
    dimVariant: number | undefined;
    readyToRunSync?: boolean;

    static observedAttributes = [READY_TO_RUN_ATTR, QUANTITY_CHECK_ATTR, DIMENSION_VARIANT_ATTR];

    constructor() {
        super();

        this.asyncURLEncrypt = this.getAttribute('data-tk-async-crypt');
        this.readyToRun = this.getAttribute(READY_TO_RUN_ATTR) === 'true';
        this.isCached = this.hasAttribute('data-tk-is-cached');
        this.checkQuantity = Number(this.getAttribute(QUANTITY_CHECK_ATTR));
        this.dimVariant = Number(this.getAttribute(DIMENSION_VARIANT_ATTR));
        this.readyToRunSync = this.hasAttribute('data-tk-ready-to-run-sync');
    }

    connectedCallback(): void {
        if ((this.hasAttribute(READY_TO_RUN_ATTR) && !this.readyToRun) || this.isCached) return;
        if (!this.checkQuantity || this.readyToRunSync) super.connectedCallback();
        else {
            this.init();
        }
    }

    init() {
        const item: StockData = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this,
        };
        this.handleStock(item);
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (name === READY_TO_RUN_ATTR && newValue === 'true') {
            !this.isCached && super.connectedCallback();
        } else if (this.checkQuantity && name === QUANTITY_CHECK_ATTR && Number(newValue) !== this.checkQuantity) {
            this.checkQuantity = Number(newValue);
            this.init();
        } else if (this.checkQuantity && name === DIMENSION_VARIANT_ATTR && Number(newValue) !== this.dimVariant) {
            this.dimVariant = Number(newValue);
            this.init();
        }
    }

    handleStock(item: StockData) {
        const items = TKStock.getItemsAsEntrypoint([item]);

        const data = {
            ...items,
            checkQuantity: this.checkQuantity || '',
            dimVariant: this.dimVariant || '',
        } as Record<string, string>;

        this.asyncURLEncrypt && (data.crypt = this.asyncURLEncrypt);

        fetchRequest({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this),
        });
    }

    static getItemsAsArray(data: StockData[]) {
        const allArticles = data.map((item) => item.articleId);
        const articles = [...new Set(allArticles)];
        return articles;
    }

    refreshStock(_item: StockData, responseItem: ResponseItem) {
        const { html } = responseItem;
        if (!html) return;
        const htmlString = isBase64(html) ? fromBase64(html) : html;
        this.innerHTML = '';
        this.insertAdjacentHTML('beforeend', htmlString);
    }
}
